import { Component} from '@angular/core';
import {Message} from 'primeng/components/common/api';
@Component({
	selector: 'info-tile',
	inputs:['title','data','dataTooltip','icon','loading'],
	templateUrl: './info-tile.component.html',
	styleUrls: ['./info-tile.component.css']
})
export class InfoTileComponent  {
	loading:boolean;
	title:string;
	data:string;
	icon:string;
	dataTooltip: string;
	hover=false;
	copied=false;
	msgs: Message[] = [];
	enter(event: any): void {
		this.hover = true;
	}

	leave(event: any): void {
		this.hover = false;
	}

	copyConfirm() {
		this.msgs = [];
		this.msgs.push({severity:'info', summary:'', detail:'Copied to Clipboard'});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/utility/info-tile/info-tile.component.ts